<template>
    <div :class="buttonClasses">
        <router-link v-if="link_type === 'page'"
                     :to="routerLink">
            <div class="button-copy">
                {{ text }}
            </div>
            <div class="arrow-container">
                <arrow></arrow>
            </div>
        </router-link>
        <a v-else
           :href="urlLink"
           @click="scrollToAnchor"
           :target="target_blank ? '_blank':''">
            <div class="button-copy">
                {{ text }}
            </div>
            <div v-if="forceArrowOn || routerLink && arrowOn" class="arrow-container">
                <arrow :hover-on="true"></arrow>
            </div>
        </a>
    </div>
</template>

<script>
    import Arrow from '../svgs/Arrow'

    export default {
        name: "ButtonLink",
        components: { Arrow },
        props: {
            button_style: {
                type: String,
                default: 'block'
            },
            link_type: {
                type: String,
                default: 'page'
            },
            text: {
                type: String,
                default: 'Click here'
            },
            url: {
                type: String,
                default: ''
            },
            page: {
                type: String,
                default: ''
            },
            anchor: {
                type: String,
                default: ''
            },
            target_blank: {
                type: Boolean,
                default: false
            },
            arrowOn: {
                type: Boolean,
                default: true
            },
            forceArrowOn: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            buttonClasses() {
                return `button ${this.button_style}`
            },
            routerLink() {
                return this.url.replace(location.origin, '')
            },
            urlLink() {
                return this.link_type === 'anchor' ? `#${this.anchor}`:this.page;
            },
            routerLink() {
                return this.page.replace(location.origin, '')
            }
        },
        methods: {
            scrollToAnchor() {
                if (this.link_type === 'anchor') {
                    this.$scrollTo(`#${this.anchor}`, 500);
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

    .button {
        display: flex;
        font-weight: 600;

        a {
            color: $white;
            text-decoration: none;
            display: flex;
        }

        &:hover {
            cursor: pointer;
        }

        &.block {
            height: 50px;
            padding: 15px;
            min-width: 190px;
            max-width: 215px;
            align-items: center;
            font-size: 12px;
            text-transform: uppercase;
            width: min-content;
            @include orange-hover;

            a {
                width: 100%;
                justify-content: space-between;
                align-items: center;

                &:hover {
                    color: white;
                }
            }
        }

        &.link {
            font-size: 20px;
            max-width: 128px;

            a {
                flex-direction: column;
                text-transform: capitalize;
                color: $white;
                transition: color .5s;

                .button-copy {
                    margin-bottom: 20px;
                }

                &:hover {
                    color: $theme-orange;

                    /deep/ .line .white-stroke {
                        transition: stroke .5s;
                        stroke: $theme-orange;
                    }
                }
            }
        }
    }
</style>
